export function OutlineFocusIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9999 12.9988C13.5513 12.9988 13.9983 12.5518 13.9983 12.0004C13.9983 11.449 13.5513 11.002 12.9999 11.002C12.4485 11.002 12.0015 11.449 12.0015 12.0004C12.0015 12.5518 12.4485 12.9988 12.9999 12.9988Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9999 18.9988C16.865 18.9988 19.9983 15.8655 19.9983 12.0004C19.9983 8.13525 16.865 5.00195 12.9999 5.00195C9.13476 5.00195 6.00146 8.13525 6.00146 12.0004C6.00146 15.8655 9.13476 18.9988 12.9999 18.9988Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 3V6.99841"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0017 12H22.0001"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 17.002V21.0004"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99841 12H4"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
